<div class="users-administration-container container">
  <div class="page-header" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="15px">
    <div fxLayout="column">
      <h1 class="mat-h1 color-primary text-small-caps no-bottom-margin">{{ 'userAdmin.title' | translate }}</h1>
      <span class="tab-description color-muted">{{ 'userAdmin.selectUser' | translate }}</span>
    </div>
    <div fxFlex></div>
    <!-- (click)="openCreateUserWizard()" [matTooltip]="'userAdmin.createUser' | translate" -->
    <mtn-icon-button color="accent" [disabled]="true" matTooltip="Feature disabled for Insights entitlements">
      <fa-icon icon="plus"></fa-icon>
    </mtn-icon-button>
    <mtn-text-field
      [form]="filterForm"
      controlName="filter"
      [placeholder]="'userAdmin.filterPlaceholder' | translate"
      mtnAnalyticsEventTrigger
      [analyticsEventName]="AnalyticsEventType.TOUCH_FORM_FIELD"
      analyticsEventBind="blur"
      [analyticsEventParameters]="{'target': 'filter'}"
      [noErrorPadding]="true">
    </mtn-text-field>
  </div>

  <div class="table-container container">
    <mtn-spinner [size]="SpinnerSize.LARGE" #usersSpinner [on]="isLoading"></mtn-spinner>
    <div class="no-data-container" fxLayout="row" fxLayoutAlign="center center" *ngIf="!isLoading && !dataSource?.data?.length">
      {{ 'userAdmin.noResults' | translate }}
    </div>

    <table mat-table [dataSource]="dataSource" matSort matSortActive="email" matSortDirection="asc"
           [hidden]="isLoading || !dataSource?.data?.length">

      <!-- Name Column -->
      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'userAdmin.name' | translate }}</th>
        <td mat-cell *matCellDef="let user">
          <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="15px">
            <mtn-user-initials-avatar [user]="user"></mtn-user-initials-avatar>
            <div fxLayout="column">
              <strong>{{ user.getDisplayName() }}</strong>
              <span class="color-muted">{{ user.title }}</span>
            </div>
          </div>
        </td>
      </ng-container>

      <!-- Email Column -->
      <ng-container matColumnDef="email">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'userAdmin.email' | translate }}</th>
        <td mat-cell *matCellDef="let user">
          {{ user.email }}
        </td>
      </ng-container>

      <!-- Company Column -->
      <ng-container matColumnDef="company">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'userAdmin.company' | translate }}</th>
        <td mat-cell *matCellDef="let user">
          <div><strong>{{ user.company?.name }}</strong></div>
          <div><small class="color-muted">{{ user.company?.uniqueIdentifier }}</small></div>
        </td>
      </ng-container>

      <!-- Last Login Date Column -->
      <ng-container matColumnDef="lastLoginDate">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'userAdmin.lastLoginDate' | translate }}</th>
        <td mat-cell *matCellDef="let user">
          <div>{{ user.lastLoginDate | insightsTimestamp }}</div>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row class="clickable" *matRowDef="let row; columns: displayedColumns;"
          (click)="navigateToUserDetails(row)"></tr>

      <!-- No Data Row -->
      <tr class="mat-row" *matNoDataRow>
        <td class="mat-cell text-center" colspan="3">
          <strong>0</strong> {{ 'userAdmin.resultsMatch' | translate }} <strong>{{ dataSource?.data?.length }}</strong>
        </td>
      </tr>
    </table>

    <mat-paginator
      [pageSize]="PAGE_SIZE"
      [length]="totalResults"
      [pageIndex]="currentPage"
      [showFirstLastButtons]="true"
      [hidePageSize]="true"
      (page)="onPageChange($event)"
      [hidden]="totalResults <= PAGE_SIZE">
    </mat-paginator>
  </div>
</div>
